import script from "./Chapter.vue?vue&type=script&lang=ts&setup=true"
export * from "./Chapter.vue?vue&type=script&lang=ts&setup=true"

import "./Chapter.vue?vue&type=style&index=0&id=d93c99a8&lang=postcss&scoped=true"

import exportComponent from "/Users/benedge/Projects/KPMG-30-Voices-FS-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d93c99a8"]])

export default __exports__